// const KnowledgeBase = () => {

//   return (<>
//     <div
//       className="title-text" style={{ marginBottom: "0", textAlign: "center", fontSize: "20px", padding: "12px 12px 0 12px" }}>
//       Knowledge Base
//     </div>
//     <div className="event-container" style={{ padding: "14px", cursor: "pointer" }}>

//     </div>
//   </>
//   );
// };
// export default KnowledgeBase;
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
interface Chapter {
  name: string;
  type: string;
  url?: string;
}

interface Lesson {
  title: string;
  chapters: Chapter[];
}

interface Book {
  name: string;
  lessons: Lesson[];
}

interface Material {
  name: string;
}

interface Subject {
  subject: string;
  period: string;
  incharge: string;
  books: Book[];
  materials: Material[];
}

const KnowledgeBase = () => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(1);
  const [selectedSubject, setSelectedSubject] = useState<Subject | null>(null);
  const [selectedBook, setSelectedBook] = useState<Book | null>(null);
  const [isBooksExpanded, setIsBooksExpanded] = useState(false);
  const [isMaterialsExpanded, setIsMaterialsExpanded] = useState(false);
  const [expandedLessonIndex, setExpandedLessonIndex] = useState<number | null>(null);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [playingVideo, setPlayingVideo] = useState<string | null>(null);
  const scheduls = [
    {
      subject: "Maths",
      period: "Period 1",
      incharge: "Mr. John",
      books: [
        {
          name: "Telugu Math Book",
          lessons: [
            {
              title: "Lesson 1",
              chapters: [
                {
                  name: "Introduction to Sets",
                  type: "video",
                  url: "https://www.w3schools.com/html/mov_bbb.mp4",
                },
                {
                  name: "Rational Numbers",
                  type: "pdf",
                  url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
                },
                {
                  name: "Formula Chart",
                  type: "image",
                  url: "https://picsum.photos/700/450",
                },
              ],
            },
            {
              title: "Lesson 2",
              chapters: [
                {
                  name: "Linear Equations",
                  type: "pdf",
                  url: ""
                },
              ],
            },
          ],
        },
        {
          name: "English Math Book",
          lessons: [],
        },
      ],
      materials: [
        {
          name: "Formula Sheet",
        },
        {
          name: "Practice Video",
        },
        {
          name: "Revision Image",
        },
      ],
    },
    {
      subject: "Physics",
      period: "Period 2",
      incharge: "Dr. Smith",
      books: [],
      materials: [],
    },
  ];

  const selectSubject = (item: Subject) => {
    setSelectedSubject(item);
    setCurrentStep(2);
    setIsBooksExpanded(false);
    setIsMaterialsExpanded(false);
    setSelectedBook(null);
    setExpandedLessonIndex(null);
  };

  const toggleBooksCard = () => {
    setIsBooksExpanded((prev) => !prev);
  };

  const toggleMaterialsCard = () => {
    setIsMaterialsExpanded((prev) => !prev);
  };

  const goToLessonPlans = () => {
    navigate(''
    );
  };

  const selectBook = (book: Book) => {
    setSelectedBook(book);
    setCurrentStep(3);
    setExpandedLessonIndex(null);
  };

  const toggleLessonAccordion = (index: number) => {
    setExpandedLessonIndex(
      expandedLessonIndex === index ? null : index
    );
  };

  const playVideo = (url: string) => {
    if (playingVideo === url) {
      setPlayingVideo(null);
    } else {
      setPlayingVideo(url);
    }
  };

  const openPdf = (url: string) => {
    window.open(url, "_blank");
  };

  const openModal = (url: string) => {
    setSelectedImage(url);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setSelectedImage(null);
    document.body.style.overflow = "auto";
  };

  const goBack = () => {
    if (currentStep === 3) {
      setSelectedBook(null);
      setExpandedLessonIndex(null);
      setCurrentStep(2);
      return;
    }

    if (currentStep === 2) {
      setSelectedSubject(null);
      setIsBooksExpanded(false);
      setIsMaterialsExpanded(false);
      setCurrentStep(1);
    }
  };

  return (
    <>
      <div className="title-text" style={{ marginBottom: 0, textAlign: "center", fontSize: "20px", padding: "12px 12px 0 12px" }}>
        Knowledge Base
      </div>

      <div className="event-container" style={{ padding: "14px" }}>
        {/* STEP 1 - Subjects */}
        {currentStep === 1 && (
          <div>
            {scheduls.map((item, index) => (
              <div
                key={index} onClick={() => selectSubject(item)}
                style={{
                  background: "#fff",
                  borderRadius: "8px",
                  padding: "10px",
                  marginBottom: "5px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                  display: "flex", justifyContent: "space-between", alignItems: "center",
                  cursor: "pointer",
                }}              >
                <h4>{item.subject}</h4>
                <small>{item.period} - {item.incharge}</small>
              </div>
            ))}
          </div>
        )}

        {/* STEP 2 */}
        {currentStep === 2 && selectedSubject && (
          <>
            <button onClick={goBack} style={{ border: 0, backgroundColor: "white", padding: "10px", color: "var(--colorAccent)" }}> ←  <b>{selectedSubject.subject}</b></button>
            <div
              onClick={toggleBooksCard}
              style={{
                borderRadius: 10, padding: 10, margin: 5, boxShadow: "0 2px 6px rgba(0,0,0,.15)", cursor: "pointer"
              }} >
              <b style={{ color: "var(--colorPrimary)" }}>Books</b>
              {isBooksExpanded &&
                selectedSubject.books.map((book: Book, index: number) => (
                  <div
                    key={index}
                    onClick={() => selectBook(book)}
                    style={{
                      marginTop: "10px",
                      cursor: "pointer",
                    }}>• {book.name}
                  </div>
                ))}
            </div>
            <div onClick={toggleMaterialsCard}
              style={{
                borderRadius: 10, padding: 10, margin: 5, boxShadow: "0 2px 6px rgba(0,0,0,.15)", cursor: "pointer",
              }} >
              <b style={{ color: "var(--colorPrimary)" }}>Materials</b>
              {isMaterialsExpanded &&
                selectedSubject.materials.map((material: Material, index: number) => (
                  <div key={index} style={{
                    marginTop: "10px",
                    cursor: "pointer",
                  }}>• {material.name}</div>
                ))}
            </div>
            <div onClick={goToLessonPlans}
              style={{
                borderRadius: 10, padding: 10, margin: 5, boxShadow: "0 2px 6px rgba(0,0,0,.15)", cursor: "pointer"
              }} >
              <b style={{ color: "var(--colorPrimary)" }}>Lesson Plans</b>
            </div>
          </>
        )}

        {/* STEP 3 */}
        {currentStep === 3 && selectedBook && (
          <>
            <button onClick={goBack} style={{ border: 0, backgroundColor: "white", padding: "10px", color: "var(--colorAccent)" }}> ←  <b>{selectedBook.name}</b> </button>
            {selectedBook.lessons.map((lesson: Lesson, index: number) => (
              <div
                key={index}
                style={{
                  marginBottom: "10px",
                  padding: "10px",
                  borderRadius: "10px",
                  boxShadow: "0 2px 8px rgba(0,0,0,.15)",
                }}
              >
                <h4
                  style={{ cursor: "pointer" }}
                  onClick={() => toggleLessonAccordion(index)}
                >
                  {lesson.title}
                </h4>
                {expandedLessonIndex === index &&
                  lesson.chapters.map((chapter: Chapter, idx: number) => (
                    <div
                      key={idx}
                      style={{
                        paddingLeft: "20px",
                        marginBottom: "10px",
                      }}
                    >
                      <div
                        onClick={() => {
                          if (chapter.type === "video" && chapter.url) playVideo(chapter.url);
                          if (chapter.type === "pdf" && chapter.url) openPdf(chapter.url);
                          if (chapter.type === "image" && chapter.url) openModal(chapter.url);
                        }}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "12px 15px",
                          cursor: "pointer",
                          borderTop: "1px solid #eee",
                        }}
                      >
                        <span>
                          {chapter.type === "video"}
                          {chapter.type === "pdf"}
                          {chapter.type === "image"}
                          {chapter.name}
                        </span>
                      </div>
                      {chapter.type === "video" &&
                        playingVideo === chapter.url && (
                          <div style={{ padding: "10px" }}>
                            <video
                              controls
                              autoPlay
                              style={{
                                width: "100%",
                                maxWidth: "600px",
                                borderRadius: "8px",
                              }}
                            >
                              <source src={chapter.url} type="video/mp4" />
                              Your browser does not support the video tag.
                            </video>
                          </div>
                        )}
                    </div>
                  ))}
              </div>
            ))}
          </>
        )}
      </div>

      {selectedImage && (
        <div
          onClick={closeModal}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <img
            src={selectedImage}
            alt=""
            style={{
              maxWidth: "85%",
              maxHeight: "85%",
            }}
          />
        </div>
      )}

    </>
  );
};

export default KnowledgeBase;